import { Component, h, Host, Prop } from '@stencil/core'
import { css } from 'src/lib/emotion'
import { classes } from 'src/utils/css'

import { IconName, icons } from '../../icons'
import { FontSizeType } from '../../tailwind'

const styleFill = css`
  & > * {
    pointer-events: none;
  }
  [icon-container] > svg {
    fill: currentColor;
    width: 1em;
    height: 1em;
  }
`

const styleStroke = css`
  & > * {
    pointer-events: none;
  }
  [icon-container] > svg {
    fill: none;
    stroke: currentColor;
    width: 1em;
    height: 1em;
  }
`

@Component({
  tag: 'ui-icon',
})
export class Icon {
  @Prop() icon: IconName
  /** Size of the icon, follows the text scale */
  @Prop() size: FontSizeType | 'auto' = 'auto'
  @Prop() useStroke = false

  render() {
    return (
      <Host
        class={`inline-flex ${classes(this.useStroke, styleStroke, styleFill)} ${classes(
          this.size !== 'auto',
          `text-${this.size}`
        )}`}
      >
        <div icon-container innerHTML={icons[this.icon]} />
      </Host>
    )
  }
}
